/**
 * Smooth Scroll & Anchor Offset Handler - Guitar Tech
 * Handles anchor links (e.g. #nos-services, #notre-equipe) with accurate sticky header offset.
 */
(function () {
  'use strict';

  function getHeaderHeight() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('.header') || document.querySelector('header');
    if (header) {
      return header.offsetHeight;
    }
    var cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    if (cssVar) {
      var parsed = parseInt(cssVar, 10);
      if (!isNaN(parsed) && parsed > 0) return parsed;
    }
    return window.innerWidth <= 768 ? 60 : 90;
  }

  function getTargetElement(hash) {
    if (!hash || hash === '#' || hash === '#!') return null;
    var cleanId = hash.replace(/^#/, '');

    // 1. Direct getElementById
    var el = document.getElementById(cleanId);
    if (el) return el;

    // 2. Query selector with escaped ID
    try {
      el = document.querySelector(hash);
      if (el) return el;
    } catch (e) {}

    // 3. Match data attributes
    try {
      el = document.querySelector('[data-anchor-target="' + cleanId + '"]') ||
           document.querySelector('[data-anchor-header="' + cleanId + '"]');
      if (el) return el;
    } catch (e) {}

    return null;
  }

  function scrollToTarget(target, updateUrl, hash) {
    if (!target) return;
    var headerHeight = getHeaderHeight();
    var offsetGap = 16;
    var rect = target.getBoundingClientRect();
    var targetTop = rect.top + window.pageYOffset - headerHeight - offsetGap;

    window.scrollTo({
      top: Math.max(0, Math.round(targetTop)),
      behavior: 'smooth'
    });

    if (updateUrl && hash && window.history && window.history.pushState) {
      window.history.pushState(null, '', hash);
    }
  }

  // Intercept anchor clicks
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;

    var rawHref = link.getAttribute('href');
    if (!rawHref || rawHref === '#' || rawHref.indexOf('#!') === 0) return;

    var hashIndex = rawHref.indexOf('#');
    var hash = rawHref.substring(hashIndex);
    var target = getTargetElement(hash);
    if (!target) return;

    // Check if it's the current page
    var path = rawHref.substring(0, hashIndex);
    var isCurrentPage = (
      path === '' ||
      path === window.location.pathname ||
      link.pathname === window.location.pathname
    );

    if (isCurrentPage) {
      e.preventDefault();
      scrollToTarget(target, true, hash);
    }
  });

  // Handle direct hash navigation on page load
  function checkInitialHash() {
    if (!window.location.hash) return;
    var target = getTargetElement(window.location.hash);
    if (target) {
      setTimeout(function () {
        scrollToTarget(target, false, null);
      }, 150);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkInitialHash);
  } else {
    checkInitialHash();
  }
})();
